import React from "react";

import { useTranslation } from "react-i18next";

import { RequestFormTopMessage } from "../RequestComponents/RequestFormTopMessage";

interface IProps {
  remark?: string | null;
}

export const TopMessageSchoolRemark = ({ remark }: IProps) => {
  const { t } = useTranslation();

  if (!remark) return null;

  return (
    <RequestFormTopMessage
      title={t("institutionDataStep.schoolRemark")}
      infoMessage={remark}
      color="info"
    />
  );
};
